import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { DataService } from './data.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from '../../../../services/common.service';
import { GenericUtils } from '../../../../utilities/generic-utils';

@Component({
  selector: 'transportation-highlights',
  templateUrl: './transportation-highlights.component.html',
  styleUrls: ['./transportation-highlights.component.scss'],
  providers: [DataService]
})
export class TransportationHighlightsComponent implements OnInit, OnChanges, OnDestroy {

  private unsubscribe: Subject<void> = new Subject();
  @Input() TITLE = "";
  @Input() API = "";
  @Input() TEXT = "";
  @Input() TOTAL: any = 0;
  dataLoading = false;
  data: any;

  constructor(private service: DataService,
    private commonService: CommonService,
    private genericUtils: GenericUtils) { }

  ngOnChanges() {
      this.data = '';
      this.dataLoading = false;
    if (!this.API && Object.keys(this.TOTAL)) {
      this.data = this.TOTAL['value'];
      this.dataLoading = true;
    }
  }

  ngOnInit() {
  }

  individualInventory() {
    this.service.getData(this.API).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (res['data'].length && res['data'][0] && Object.keys(res['data'][0]).length) {
        const calculateValue = {}
        const inventoryListingStorageGroup = res['data'][0]['InventoryListingStorageGroup'];
        calculateValue['percentage'] = (inventoryListingStorageGroup[0]['total_quantity'] / this.TOTAL[0]['total_quantity']) * 100;
        calculateValue['byValue'] = inventoryListingStorageGroup[0]['total_value'];
        this.data = calculateValue;
      } else {
        this.data = '';
        this.dataLoading = true;
      }
    }, error => {
      this.data = '';
      this.dataLoading = true;
    })
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
